/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import {
    REQUEST_APP_CONFIGS,
    RECEIVE_APP_CONFIGS,
    CLEAR_STATE,
    CLOSE_PASSWORD_MODAL,
    SUBMIT_PASSWORD,
    SUBMIT_PASSWORD_FAILED,
    RECEIVE_TEST_KMS_CONNECTION,
    REQUEST_TEST_KMS_CONNECTION,
    REQUEST_LDI_IMPORT_AVAILABILITY,
    RECEIVE_LDI_IMPORT_AVAILABILITY,
    RECEIVE_LDI_IMPORT,
    REQUEST_LDI_IMPORT,
    REQUEST_REVERT_OPTIONS,
    RECEIVE_REVERT_OPTIONS,
    REQUEST_REVERT_TO_VERSION,
    RECEIVE_REVERT_TO_VERSION,
    REQUEST_MEMORY_REQUIREMENTS,
    RECEIVE_MEMORY_REQUIREMENTS
} from "./AppConfigActions";
import {ASK_FOR_PASSWORD} from "../learningLoop/LearningLoopActions";
import {LdiImportAvailabilityResult, LdiImportRevertResult} from "../../api/AppConfigs";

const initialState = {
    error: null,
    loading: false,
    appConfigData: [],
    kmsConnection: {
        success: null,
        connectionError: {
            errorKey: null,
        },
        submitPasswordModalOpen: false,
        loading: false,
        password: '',
    },
    importLoading: false,
    ldiImport: {
        result: null,
        wasRevertSuccessful: null,
        ldiValidationResults: null,
    },
    ldiImportAvailabilityResult: {
        ldiImportAvailabilityResult: LdiImportAvailabilityResult.LDI_IMPORT_NO_UPDATE_NEEDED,
        currentLdiVersion: null,
        newLdiVersion: null,
    },
    revertOptions: [],
    revertResult: {
        result: LdiImportRevertResult.LDI_IMPORT_REVERT_NO_INFORMATION,
        revert: null,
        databaseValidationResults: null,
        databaseType: '',
    },
    freeSpace: null,
    expectedNeededSpace: null,
}

export const appConfigsReducer = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_APP_CONFIGS:
            return {
                ...state,
                loading: true,
            }
        case RECEIVE_APP_CONFIGS:
            return {
                ...state,
                loading: false,
                appConfigData: action.appConfigData,
                error: null,
            }
        case CLOSE_PASSWORD_MODAL:
            return {
                ...state,
                kmsConnection: {
                    ...state.kmsConnection,
                    loading: false,
                    submitPasswordModalOpen: false,
                },
            }
        case SUBMIT_PASSWORD:
            return {
                ...state,
                kmsConnection: {
                    ...state.kmsConnection,
                    loading: true,
                    password: state.password,
                },
            }
        case SUBMIT_PASSWORD_FAILED:
            return {
                ...state,
                kmsConnection: {
                    ...state.kmsConnection,
                    loading: false,
                    connectionError: action.error,
                },
            }
        case ASK_FOR_PASSWORD:
            return {
                ...state,
                kmsConnection: {
                    ...state.kmsConnection,
                    loading: false,
                    submitPasswordModalOpen: true,
                },
            }
        case REQUEST_TEST_KMS_CONNECTION:
            return {
                ...state,
                kmsConnection: {
                    ...state.kmsConnection,
                    loading: true,
                },
            }
        case RECEIVE_TEST_KMS_CONNECTION:
            return {
                ...state,
                kmsConnection: {
                    ...state.kmsConnection,
                    loading: false,
                    success: action.success,
                    connectionError: action.error,
                },
            }
        case CLEAR_STATE:
            return initialState
        case REQUEST_LDI_IMPORT_AVAILABILITY:
            return {
                ...state,
                importLoading: true,
                ldiImportAvailabilityResult: {
                    ldiImportAvailabilityResult: LdiImportAvailabilityResult.LDI_IMPORT_NO_UPDATE_NEEDED,
                    currentLdiVersion: null,
                    newLdiVersion: null,
                    errorMessage: '',
                },
                revertResult: {
                    result: LdiImportRevertResult.LDI_IMPORT_REVERT_NO_INFORMATION,
                    revert: null,
                    databaseValidationResults: null,
                    databaseType: '',
                },
                ldiImport: {
                    result: null,
                    wasRevertSuccessful: null,
                    ldiValidationResults: null,
                },
            }
        case RECEIVE_LDI_IMPORT_AVAILABILITY:
            return {
                ...state,
                importLoading: false,
                ldiImportAvailabilityResult: action.ldiImportAvailabilityResult,
            }
        case REQUEST_LDI_IMPORT:
            return {
                ...state,
                ldiImport: {
                    result: null,
                    wasRevertSuccessful: null,
                    ldiValidationResults: null,
                },
                ldiImportAvailabilityResult: {
                    ldiImportAvailabilityResult: LdiImportAvailabilityResult.LDI_IMPORT_NO_UPDATE_NEEDED,
                    newLdiVersion: null,
                    currentLdiVersion: null,
                    errorMessage: '',
                },
                importLoading: true,
                revertResult: {
                    result: LdiImportRevertResult.LDI_IMPORT_REVERT_NO_INFORMATION,
                    revert: null,
                    databaseValidationResults: null,
                    databaseType: '',
                },
            }
        case RECEIVE_LDI_IMPORT:
            return {
                ...state,
                ldiImport: {
                    result: action.ldiImportResult.ldiImportUpdateResult,
                    wasRevertSuccessful: action.ldiImportResult.successfulRevert,
                    ldiValidationResults: action.ldiImportResult.validationResults,
                },
                ldiImportAvailabilityResult: action.ldiImportResult.ldiImportAvailability,
                importLoading: false,
            }
        case REQUEST_REVERT_OPTIONS:
            return {
                ...state,
                revertOptions: [],
                importLoading: true,
                revertResult: {
                    result: LdiImportRevertResult.LDI_IMPORT_REVERT_NO_INFORMATION,
                    revert: null,
                    databaseValidationResults: null,
                    databaseType: '',
                },
            }
        case RECEIVE_REVERT_OPTIONS:
            return {
                ...state,
                revertOptions: action.ldiImportRevertOptions,
                importLoading: false,
            }
        case REQUEST_REVERT_TO_VERSION:
            return {
                ...state,
                revertResult: {
                    result: LdiImportRevertResult.LDI_IMPORT_REVERT_NO_INFORMATION,
                    revert: null,
                    databaseValidationResults: null,
                    databaseType: '',
                },
                ldiImportAvailabilityResult: {
                    ldiImportAvailabilityResult: LdiImportAvailabilityResult.LDI_IMPORT_NO_UPDATE_NEEDED,
                    newLdiVersion: null,
                    currentLdiVersion: null,
                    errorMessage: '',
                },
                ldiImport: {
                    result: null,
                    wasRevertSuccessful: null,
                },
                importLoading: true,
            }
        case RECEIVE_REVERT_TO_VERSION:
            return {
                ...state,
                revertResult: {
                    result: action.ldiRevertResult.result,
                    revert: action.ldiRevertResult.successfulRevert,
                    databaseValidationResults: action.ldiRevertResult.validationResults,
                    databaseType: action.ldiRevertResult.databaseType,
                },
                importLoading: false,
                ldiImportAvailabilityResult: action.ldiRevertResult.ldiImportAvailability,
            }
        case REQUEST_MEMORY_REQUIREMENTS:
            return {
                ...state,
                freeSpace: null,
                expectedNeededSpace: null,
                loading: true,
            }
        case RECEIVE_MEMORY_REQUIREMENTS:
            return {
                ...state,
                freeSpace: action.memoryRequirements.freeSpace,
                expectedNeededSpace: action.memoryRequirements.expectedNeededSpace,
                loading: false,
            }
        default:
            return state
    }
}